import { axiosInstance } from "../axiosConfig";

export default async function getUser() {
  try {
    const { data } = await axiosInstance.get("/admin/get_all_user");
    return data;
  } catch (error) {
    throw error;
  }
}
